var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2C0 0.89543 1.11929 0 2.5 0H32.5C33.8807 0 35 0.89543 35 2C35 3.10457 33.8807 4 32.5 4H2.5C1.11929 4 0 3.10457 0 2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 10.8954 1.11929 10 2.5 10H32.5C33.8807 10 35 10.8954 35 12C35 13.1046 33.8807 14 32.5 14H2.5C1.11929 14 0 13.1046 0 12Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 22C0 20.8954 1.11929 20 2.5 20H32.5C33.8807 20 35 20.8954 35 22C35 23.1046 33.8807 24 32.5 24H2.5C1.11929 24 0 23.1046 0 22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSidebar);
export default __webpack_public_path__ + "static/media/WhiteSidebar.351e52f0.svg";
export { ForwardRef as ReactComponent };